import type { Formatter } from '../types';

export const formatter: Formatter = (
  severity: string,
  _key: string,
  message: string,
  context: any,
) => [`[${severity}] ${message}`, context];
